import { Row, Col, Card, Badge, Form, Stack } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { store } from 'Store';
import { useDispatch } from "react-redux";
import { useEffect, useRef, useReducer } from "react";
import { FormTextInput } from "Components/Forms/FormInput";
import { formInfoReducer, ACTIONS } from "../VendorFormDataReducer";
import { loadFormInfo, submitAddVendorAuth } from "../VendorAxiosFuncs";
import ErrorIcon from '@mui/icons-material/ErrorOutlined';
import { TextButton } from "Components/Button";
import { STATUSES, ERROR_MESSAGES } from "Utils/constants";
import { setGlobalSuccessStatus, setGlobalErrorStatus } from 'Components/StatusHandling';
import { applyDateSelectorFormat } from "Utils/utilityFunctions";

const nameConverter = {
  "organizationId": "selectedPSOOrg",
  "vendorOrganizationId": "selectedVendor",
  "startDate": "startDate",
  "endDate": "endDate"
}

const AddVendorAuthorization = () => {

  const location = useLocation();
  const dispatch = useDispatch();
  const passedData = location.state;
  const loginState = store.getState().loginInfo;
  const token = "Bearer " + loginState.token;
  const navigate = useNavigate();

  const initialState = {
    data: '',
    loading: true,
    error: null,
  };
  const [formInfo, formInfoDispatch] = useReducer(formInfoReducer, initialState);

  const formFieldDisplay = {
    selectedPSOOrg: {
      type: 'select',
      id: 'selectedPSOOrg',
      name: 'selectedPSOOrg',
      display: {
        label: 'Select PSO Organization',
        description: "",
        title: "",
      },
      hideFieldOrgTypes: [],
      InputRef: useRef(null)
    },
    selectedVendor: {
      type: 'select',
      id: 'selectedVendor',
      name: 'selectedVendor',
      display: {
        label: 'Select Vendor',
        description: "",
        title: "",
      },
      hideFieldOrgTypes: [],
      InputRef: useRef(null)
    },
    startDate: {
      type: 'date',
      id: 'startDate',
      name: 'startDate',
      display: {
        label: 'Start Date',
        description: "",
        title: "",

      },
      hideFieldOrgTypes: [],
      InputRef: useRef(null)
    },
    endDate: {
      type: 'date',
      id: 'endDate',
      name: 'endDate',
      display: {
        label: 'End Date',
        description: "",
        title: "",

      },
      hideFieldOrgTypes: [],
      InputRef: useRef(null)
    }
  }

  var vendorListValues = (vendorList) => {
    var objArr = [];
    objArr.push({
      index: 0,
      value: null,
      title: null,
      displayValue: "Select Vendor",
      isSelected: true
    });

    for (var i = 0; i < vendorList.length; i++) {
      var x = vendorList[i];
      objArr.push({
        index: x.id,
        value: x.id,
        title: "Select vendor " + x.name,
        displayValue: x.name,
        isSelected: false
      });
    }

    return objArr;
  };

  var psoOrgListValues = (psoOrgList) => {
    var objArr = [];
    objArr.push({
      index: 0,
      value: null,
      title: null,
      displayValue: "Select PSO Organization",
      isSelected: true
    });

    for (var i = 0; i < psoOrgList.length; i++) {
      var x = psoOrgList[i];
      objArr.push({
        index: x.id,
        value: x.id,
        title: "Select PSO Organization " + x.name,
        displayValue: x.name + " (" + x.psoId + ")",
        isSelected: false
      });
    }

    return objArr;
  };

  const handleSelectChange = (e) => {
    //console.log("print out vendor select change", e);
    formInfoDispatch({
      type: ACTIONS.SELECT_CHANGE,
      value: e.target.value,
      name: e.target.name
    })
  }

  const handleInputTextChange = (e) => {
    //console.log("print out the text input date change", e, e.target.attributes.id, e.target.value);
    const val = applyDateSelectorFormat(e.target.value);

    formInfoDispatch({
      type: ACTIONS.TEXT_CHANGE,
      value: val,
      name: e.target.name
    });
  }

  useEffect(() => {

    loadFormInfo(ACTIONS, formInfoDispatch, handleSelectChange,
      handleInputTextChange, { vendorListValues, psoOrgListValues },
      token)
      .catch((error) => {
        setGlobalErrorStatus({
          dispatch: dispatch,
          popupData: {
            visible: true,
            title: ERROR_MESSAGES.DATA_ERROR.title,
            msg: ERROR_MESSAGES.DATA_ERROR.message,
            showContactHelp: true
          },
          redirect: {
            redirect: false,
            redirectFirst: false,
            path: "",
            data: {}
          },
          error: error
        });
      });

  }, []);

  var dispErrors = (fieldName) => {
    var data = formInfo.data[fieldName];
    var dispData = formFieldDisplay[fieldName];
    return (
      <div>
        {data.validation.errors.length > 0 ? data.validation.errors.map((errorText, index) =>
          <Stack key={dispData.name + "Errors_" + index} direction="horizontal" gap={2} className="align-items-start">
            <div id="errorIcon"><ErrorIcon fontSize="small"></ErrorIcon></div>
            <div>{errorText}</div>
          </Stack>

        ) : null}
      </div>
    );
  }

  var dispLabel = (fieldName, isHidden, getColLabelSizes, alignment, multi) => {

    var data = formInfo.data[fieldName];
    var dispData = formFieldDisplay[fieldName];

    //console.log("print out data, dispData, fieldName", data, dispData.display.label, fieldName, formInfo);

    if (alignment == Row) {
      if (multi == true) {
        return (
          <Col hidden={isHidden}
            xs={getColLabelSizes('xs')}
            sm={getColLabelSizes('sm')}
            md={getColLabelSizes('md')}
            lg={getColLabelSizes('lg')}
            xl={getColLabelSizes('xl')}
            xxl={getColLabelSizes('xxl')}
          >
            <legend>
              {<span className="me-2">{dispData.display.label}</span>}
              {data.validation.required ? '' : <Badge bg="optional">Optional</Badge>}
            </legend>
          </Col>
        );
      }
      else {
        return (
          <Form.Label visuallyHidden={isHidden} column
            xs={getColLabelSizes('xs')}
            sm={getColLabelSizes('sm')}
            md={getColLabelSizes('md')}
            lg={getColLabelSizes('lg')}
            xl={getColLabelSizes('xl')}
            xxl={getColLabelSizes('xxl')}
          >
            {<span className="me-2">{dispData.display.label}</span>}
            {data.validation.required ? '' : <Badge bg="optional">Optional</Badge>}
          </Form.Label>
        );
      }
    }
    else {
      if (multi == true) {
        return (
          <Row hidden={isHidden}
            xs={getColLabelSizes('xs')}
            sm={getColLabelSizes('sm')}
            md={getColLabelSizes('md')}
            lg={getColLabelSizes('lg')}
            xl={getColLabelSizes('xl')}
            xxl={getColLabelSizes('xxl')}
          >
            <legend>
              {dispData.display.label}
              {data.validation.required ? '' : <Badge bg="optional">Optional</Badge>}
            </legend>
          </Row>
        );
      }
      else {
        return (
          <Form.Label visuallyHidden={isHidden}
            xs={getColLabelSizes('xs')}
            sm={getColLabelSizes('sm')}
            md={getColLabelSizes('md')}
            lg={getColLabelSizes('lg')}
            xl={getColLabelSizes('xl')}
            xxl={getColLabelSizes('xxl')}
          >
            {dispData.display.label}
            {data.validation.required ? '' : /*<span className="optionalField"><br></br>optional</span>*/ <Badge bg="optional">Optional</Badge>}
          </Form.Label>
        );
      }

    }

  };

  function getFieldValue (fieldName, data) {
    var values = data[fieldName];
    var dispValues = formFieldDisplay[fieldName];

    //console.log(values);
    if (formInfo.loading) {
      return '';
    }
    else {
      var type = dispValues.type;
      switch (type) {
        case "text":
          if (values.value != null) {
            return values.value;
          }
          return "";
        case "date":
          if (values.value != null) {
            var split = values.value.split('-');
            //console.log(split);
            if (split.length == 3) {
              return split[1] + '/' + split[2] + '/' + split[0];
            }
            return values.value;
          }
          return "";
        case "select":
          if (values != null) {
            var arr = values.options;
            //console.log("ARR");
            //console.log(arr);
            for (var x = 0; x < arr.length; x++) {
              var val = arr[x];
              if (val.isSelected) {
                return val.value;
              }
            }
          }
          return null;
      }
    }
  }

  function addErrorMessages (fieldName, errorFieldName, data, isFirst) {
    //console.log("ADD ERROR MESSAGES", fieldName);
    var d = data.fieldErrors;
    var values = d[errorFieldName];

    if (values != null) {
      var field = formFieldDisplay[fieldName];
      var type = field.type;
      var err = values.errorMessages;

      if (isFirst == true) {
        (field.InputRef).current.focus();
        //console.log("ISFIRST");
      }

      switch (type) {
        case "text":
          formInfoDispatch({
            type: ACTIONS.TEXT_SET_ERRORS,
            name: fieldName,
            errors: err
          })
          break;
        case "date":
          formInfoDispatch({
            type: ACTIONS.TEXT_SET_ERRORS,
            name: fieldName,
            errors: err
          })
          break;
        case "select":
          formInfoDispatch({
            type: ACTIONS.SELECT_SET_ERRORS,
            name: fieldName,
            errors: err
          })
          break;
      }

    }
  }

  function clearErrorMessages (data) {
    for (const [key, value] of Object.entries(data)) {
      var t = formFieldDisplay[key];
      var fieldName = key;
      switch (t.type) {
        case "text":
          formInfoDispatch({
            type: ACTIONS.TEXT_REMOVE_ERRORS,
            name: fieldName
          })
          break;
        case "date":
          formInfoDispatch({
            type: ACTIONS.TEXT_REMOVE_ERRORS,
            name: fieldName
          })
          break;
        case "select":
          formInfoDispatch({
            type: ACTIONS.SELECT_REMOVE_ERRORS,
            name: fieldName
          })
          break;
        case "text":
          formInfoDispatch({
            type: ACTIONS.TEXT_REMOVE_ERRORS,
            name: fieldName
          })
          break;
      }
    }
  }


  const handleSubmit = async () => {
    //passedData.orgId
    var result = await submitAddVendorAuth(token, passedData.orgId, formInfo, nameConverter, addErrorMessages, clearErrorMessages, getFieldValue)
      .then((res) => {
        if (res !== null && res !== undefined) {
          //console.log("submitAddVendorAuth", res);
          var statusCode = res.data.status;
          switch (statusCode) {
            case STATUSES.ERROR.code:
              if (res.data.globalErrorMessageList && res.data.globalErrorMessageList.length != 0) {
                setGlobalErrorStatus({
                  dispatch: dispatch,
                  popupData: {
                    visible: true,
                    title: ERROR_MESSAGES.GENERAL_ERROR.title,
                    msg: res.data.globalErrorMessageList,
                    showContactHelp: true
                  },
                  redirect: {
                    redirect: false,
                    redirectFirst: false,
                    path: "",
                    data: {}
                  }
                })
              };
              break;
            case STATUSES.SUCCESS.code:
              setGlobalSuccessStatus({
                dispatch: dispatch,
                popupData: {
                  visible: true,
                  title: "Success!",
                  msg: res.data.message,
                  showContactHelp: false
                },
                redirect: {
                  redirect: true,
                  redirectFirst: true,
                  path: "/manage/authorization",
                  data: {}
                }
              });
              break;

          }
        }
      }).catch((error) => {
        //console.log("Error caught while loading data: " + error);
        //setIsLoading(false);
        setGlobalErrorStatus({
          dispatch: dispatch,
          popupData: {
            visible: true,
            title: ERROR_MESSAGES.DATA_ERROR.title,
            msg: ERROR_MESSAGES.DATA_ERROR.message,
            showContactHelp: true
          },
          redirect: {
            redirect: false,
            redirectFirst: false,
            path: "",
            data: {}
          },
          error: error
        });
      })
  }

  const handleCancel = () => {
    navigate("/manage/authorization");
  }

  return (

    <Row>
      {formInfo.loading ? null :
        <Col xl={11} lg={11} md={11} sm={12}>
          <Card className="p-4">
            <Card.Body className="text-start">
              <h1 id="mainContent" className="header1 text-start mb-3 blue bold">Add Vendor Authorization</h1>
              <h2 className="text-start mb-2 form-title">Vendor Authorization</h2>
              <br />
              <Form>
                <FormTextInput orgType={"Vendor"} fieldName="selectedPSOOrg" hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 5 } }} displayLabelFunc={dispLabel} data={formInfo.data} fieldData={formFieldDisplay} displayErrorsFunc={dispErrors}></FormTextInput>
                <FormTextInput orgType={"Vendor"} fieldName="selectedVendor" hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 5 } }} displayLabelFunc={dispLabel} data={formInfo.data} fieldData={formFieldDisplay} displayErrorsFunc={dispErrors}></FormTextInput>
                <FormTextInput orgType={"Vendor"} fieldName="startDate" hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 5 } }} displayLabelFunc={dispLabel} data={formInfo.data} fieldData={formFieldDisplay} displayErrorsFunc={dispErrors}></FormTextInput>
                <FormTextInput orgType={"Vendor"} fieldName="endDate" hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 5 } }} displayLabelFunc={dispLabel} data={formInfo.data} fieldData={formFieldDisplay} displayErrorsFunc={dispErrors}></FormTextInput>
                <br />
                <Stack className="pt-3" direction="horizontal" gap={3}>
                  {/* Submit Button */}
                  <TextButton
                    variant="normal"
                    onClick={handleSubmit}
                    content={"Submit"}
                  >
                  </TextButton>

                  {/* Cancel Button */}
                  <TextButton
                    variant="outline"
                    onClick={handleCancel}
                    content={"Cancel"}
                  >
                  </TextButton>
                </Stack>
              </Form>
            </Card.Body>
          </Card>
        </Col>}
    </Row >
  )
}

export default AddVendorAuthorization;